import LazyGruser from './LazyGruserZone';
export default LazyGruser;

//# sourceMappingURL=index.js.map